<template>
    <v-container fluid >
        <div v-if="error">
            <app-message :rang="rang"  :matn="error_message" ></app-message>
        </div>
        <div v-if="currency">
            <app-currency v-on:qurb_change="cur" />
        </div>
        <div v-if="new_firma">
            <new-firma v-on:exit_from_new_firm_dialod="new_firma = false" />
        </div>
        <div v-if="new_nakladnoy">
            <kh-nakladnoy v-on:update_nakladnoy="get_kharids" v-on:exit_kh_nakladnoy="new_nakladnoy = false" />
        </div>
        <div v-if="newmol">
            <new-mol v-on:update="new_mol_update" v-on:id_mol="add_from_newmol"/>
        </div>
        <v-row>

          <v-col>
            <v-sheet


              rounded="lg"
            >
            <v-card  v-if="table_kharid">
                <v-card-title>





                  <v-row class="mb-2">
                    <v-col cols="12" md="3">
                        <v-menu class="m-2"
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date1"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date1"
                            label="Дата 1"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date1"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                          >
                            Отмена
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="get_kharids"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>




                      <v-autocomplete
                      clearable
                      item-color="primary"
                      color="primary"
                      hide-no-data
                      label="Поставщики"
                      hide-details
                      multiple
                      solo

                      :items="firmaho"
                      item-text="nom"
                      item-value="nom"
                      class="mt-4"
                      @click:clear="get_kharids"
                      v-model="filters.firma_nom" />


                    </v-col>

                    <v-col cols="12" md="3">

                        <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date2"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date2"
                            label="Дата 2"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date2"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu2 = false"
                          >
                            Отмена
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="get_kharids"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>



                      <v-autocomplete class="mt-4"
                      clearable
                       item-color="primary"
                       color="primary"
                       hide-no-data
                       hide-details
                       multiple
                       solo

                       :items="valutaho"
                       item-text="valuta"
                       item-value="valuta"
                       label="Валюта"
                       @click:clear="get_kharids"
                       v-model="filters.nom" />
                    </v-col>

                    <v-col cols="12" md="3">



                        <v-autocomplete

                        clearable
                         item-color="primary"
                         color="primary"
                         hide-no-data
                         hide-details
                         multiple
                         solo
                         :items="statusho"
                         item-text="holat"
                         item-value="holat"
                         label="Статус"
                         @click:clear="get_kharids"
                         v-model="filters.holat" />

                        <v-autocomplete
                        class="mt-4"
                        clearable
                         item-color="primary"
                         color="primary"
                         hide-no-data
                         hide-details
                         multiple
                         solo
                         :items="joyho"
                         item-text="mesto"
                         item-value="mesto"
                         label="Место"
                         @click:clear="get_kharids"
                         v-model="filters.mesto" />

                    </v-col>

                    <v-col cols="12" md="3">



                        <v-text-field
                        color="primary"
                        prepend-inner-icon="mdi-magnify"
                        v-model="search_kod"
                        solo
                        hide-details
                        clearable
                        @click:clear="get_kharids"
                        @keyup.enter="get_kharids_from_kod"
                        label="Поиск"/>

                    </v-col>

                  </v-row>

                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="filteredProducts"
                  item-key="id_khnakladnoy"
                  :search="search_kod"
                  :loading="loading"
                  @dblclick:row="show_kharid"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
                >
                <template v-slot:item.holat="{ item }">
                      <v-icon v-if="item.holat=='Проведен'" color="success" >{{ getIcon(item.holat) }}</v-icon>
                      <v-icon v-if="item.holat=='Не Проведен'" color="warning" >{{ getIcon(item.holat) }}</v-icon>
                </template>
                <!-- actions -->
                <template   v-slot:item.actions="{ item }">
                    <v-icon color="orange" small class="mr-2" @click="edit_kharid(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon v-if="item.holat=='Не Проведен'" color="error" small @click="delete_kharid(item)">
                        mdi-delete
                    </v-icon>
                </template>

                <template slot="body.append">
                    <tr>
                        <th class="title "></th>
                        <th class="title "></th>
                        <th class="title ">Итого</th>
                        <th class="title ">{{Number( sumField('sum_kh')).toFixed(2) }}</th>
                        <th class="title ">{{Number( sumField('sum_s')).toFixed(2) }}</th>
                        <th class="title ">{{Number( sumField('sum_o')).toFixed(2) }}</th>
                        <th class="title "></th>
                        <th class="title "></th>
                        <th class="title "></th>
                        <th class="title "></th>
                    </tr>
                </template>

            </v-data-table>
              </v-card>

              <v-card v-if="table_kharid_0">
                <v-card-title>
                    <v-icon color="orange" class="mr-2" @click="back_kharid">
                        mdi-arrow-left
                    </v-icon>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-card-subtitle><h4>Закупка № <u>{{ id_khnakladnoy }}</u> - {{ nom_firma }}[{{ valuta_firma }}]</h4></v-card-subtitle>

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Поиск"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>

                <div>
                    <v-data-table
                        :search="search"
                        :headers="header_kharid_0"
                        :items="kharid"
                        :loading="loading"
                        loading-text="Загрузка. Пожалуйста подождите"
                        :footer-props="{
                            'items-per-page-options': [ 7, 20, 50, 100],
                            'items-per-page-text':'Строк на странице',
                        }"
                        no-data-text="Данные отсутствуют в таблице"


                    >




                    </v-data-table>

                    <v-snackbar
                      v-model="snack"
                      :timeout="3000"
                      :color="snackColor"
                    >
                      {{ snackText }}

                      <template v-slot:action="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          text
                          @click="snack = false"
                        >
                          Закрыть
                        </v-btn>
                      </template>
                    </v-snackbar>
                  </div>


              </v-card>








    <v-card v-if="table_kharid_1">
        <v-card-title>
            <v-icon color="orange" class="mr-2" @click="back_kharid">
                mdi-arrow-left
            </v-icon>

           <p style="color: #4CAF50"> Закупка №{{ id_khnakladnoy }} - {{ nom_firma }}[{{ valuta_firma }}]</p>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="header_kharid_0"
            :items="kharid"
            :search="search"
            :loading="loading"
            loading-text="Загрузка. Пожалуйста подождите"
            :footer-props="{
                'items-per-page-options': [ 7, 20, 50, 100],
                'items-per-page-text':'Строк на странице',
            }"
            no-data-text="Данные отсутствуют в таблице"
          >

        </v-data-table>
    </v-card>




            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
import NewFirma from '../../components/NewFirma.vue';
import axios from 'axios';
import VueBarcode from 'vue-barcode';
import moment from 'moment';
import NewMol from '../../components/NewMol.vue';



  export default {
  components: { NewFirma , NewMol,
    'barcode': VueBarcode},
    data () {
      return {

        comment:'',
        s_oplata: 0,
        oplata_dialog: false,
        radio_narkh: 'narkhi_s',
        tab: 1,
        newmol: false,

        namud_chop: null,
        shtrikh: true,
        sennik: true,

        dialog_chop: false,
        otmena_nak_dialog: false,
        radios: null,
        dialog_skidka: false,
        skidka_input: 0,
        natsenka_input: 0,
        dialog_natsenka: false,
        search_molho: '',
        error: false,
        holat_nak: false,
        id_mol: 0,
        table_kharid_0: false,
        table_kharid_1: false,
        poisk_dialog: false,
        loading: false,
        table_kharid: true,
        new_nakladnoy: false,
        new_firma: false,
        currency: false,
        usd:'',
        rub:'',
        qurbnoma: [],
        active: false,
        menu_dates: false,
        dates: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10) , (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
        search: '',
        search_kod: '',
        rang: "#D50000",
        marjaa: 0,
        picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

        menu5: false,
        delete_dialog:false,
        id_del_nak: 0,
        header_molho: [
          {
            text: 'Код',
            align: 'start',
            value: 'kod',

          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Остаток', value: 'bokimonda' },
          { text: 'Валюта', value: 'valuta' },
          { text: 'Посл.закуп.цена', value: 'narkhi_p' },
          { text: 'Себестоимость', value: 'narkhi_a' },
          { text: 'Прод.цена', value: 'narkhi_f'},
          { text: 'Прод.опт', value: 'narkhi_opt'},
          { text: 'id_mol', value: 'id_mol', align: ' d-none' },



        ],
        headers: [
          {
            text: 'ID',
            align: 'start',
            value: 'id_khnakladnoy',
          },
          { text: 'Поставщик', value: 'firma_nom' },
          { text: 'Валюта', value: 'nom' },
          { text: 'Сумма покупка', value: 'sum_kh' },
          { text: 'Сумма скидка', value: 'sum_s' },
          { text: 'Сумма к оплате', value: 'sum_o' },
          { text: 'Место', value: 'mesto' },
          { text: 'Дата', value: 'sana' },
          { text: 'Статус', value: 'holat' },


        ],

        joyho:[
            {mesto: 'Склад', value: '2'},
            {mesto: 'Магазин', value: '1'},

        ],

        statusho:[
            {holat: 'Проведен'},
            {holat: 'Не Проведен'},
        ],

        headers_view: [
          {
            text: 'ID',
            align: 'start',
            value: 'id_khnakladnoy',
          },
          { text: 'Поставщик', value: 'firma_nom' },
          { text: 'Валюта', value: 'nom' },
          { text: 'Сумма покупка', value: 'sum_kh' },
          { text: 'Сумма скидка', value: 'sum_s' },
          { text: 'Сумма к оплате', value: 'sum_o' },
          { text: 'Статус', value: 'holat' },
          { text: 'Дата', value: 'sana' },
        ],
        header_kharid_0: [
          {
            text: 'Код',
            align: 'start',
            value: 'kod',
          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Кол-во', value: 'mikdor' },
          { text: 'Закуп.Цена', value: 'narkhi_o' },
          { text: 'Скидка', value: 'skidka' },
          { text: 'Себестоимость', value: 'narkhi_a' },
          { text: 'Маржа', value: 'marja' },
          { text: 'Цена Прод', value: 'narkhi_f' },
          { text: 'Цена опт', value: 'narkhi_opt' },
          { text: 'Сумма', value: 'summa' },
          { text: 'id_mol', value: 'id_mol',  align: ' d-none' },
          { text: 'ost_kuna', value: 'ost_kuna',  align: ' d-none' },
          { text: 'narkh_kuna', value: 'narkh_kuna',  align: ' d-none' },
          { text: 'kurb_nav', value: 'kurb_nav',  align: ' d-none' },
          { text: 'kurb_kuna', value: 'kurb_kuna',  align: ' d-none' },
          { text: 'kod', value: 'kod',  align: ' d-none' },
          { text: 'muhlatnok', value: 'muhlatnok',  align: ' d-none' },
          { text: 'Годен до', value: 'muhlati_istifoda' },



        ],
        mikdorRules:[
            v => !!v || 'Обязательное поле',
            v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
            v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',
      ],
        kharid: [],
        kharids:[],
        molho: [],
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        firmaho:[],

        valutaho: [
            { valuta: "TJS", id_kurb: 1 },
            { valuta: "USD", id_kurb: 2 },
            { valuta: "RUB", id_kurb: 3 },
        ],

        filters: {
            fio: "",
            nom: "",
            valuta: "",
            firma_nom: "",
            comment: "",
            mesto:"",
            holat:"",
        },

       sana: {
            from: '',
            to: '',
        },
        molho_list: {
            id_nakl: '',
            id_mol: '',
            narkhi_p: '',
            narkhi_f: '',
            narkhi_a: '',
            id_kurb: '',
        },

        export_kharids_fields: [

            {
              'title': 'Код',
              'name': 'kod',
              'width': '20',
            },
            {
              'title': 'Наименование',
              'name': 'nom',
              'width': '40'

            },
            {
              'title': 'Кол-во',
              'name': 'mikdor',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Закуп.Цена',
              'name': 'narkhi_o',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Скидка',
              'name': 'skidka',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Себестоимость',
              'name': 'narkhi_a',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Маржа',
              'name': 'marja',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Цена Прод',
              'name': 'narkhi_f',
              'type': 'float',
              'width': '15'
            },
            {
              'title': 'Сумма',
              'name': 'summa',
              'type': 'float',
              'width': '15'
            },


        ],

        id_khnakladnoy: 0,
        sum_kharid:0,
        sum_skidka:0,
        sum_k_oplate:0,

        nom_firma: '',
        valuta_firma: '',
        id_kurb_firma: 0,
        id_firma: '',
        deleteIndex: -1,
        chop: {},
        css: `
        <style>


        .div_2{
            margin: 0;
            padding: 0;
        }

        .nom{
            text-align: center;
          color: #000;
          font-size: 16pt;
          margin:0;
          line-height: 1;
          font-weight: bold;
          margin-top:0px;

        }
        .nom2{
        text-align: center;
          color: #000;
          font-size: 12pt;
          margin:0;
          line-height: 1;

          margin-top:0px;

        }
        .narkh{

          color: #000;
          font-size: 22pt;
          margin:0;
          line-height: 1;
          font-weight: bold;
          margin-top:0px;
          text-align: center;

        }
        .sh_kod{
            text-align: center
        }
        .div_narkh{

            position: absolute;
            text-align: center;
        }


        </style>
        `,


        natsenka_radio: '1',
        snack: false,
        snackColor: '',
        snackText: '',
        max25chars: v => v.length <= 25 || 'Input too long!',
        pagination: {},
        text: '',
        endpointNumber: 1,

        barcode_dialog: false,

        label_1540:[
            "nom",
            "kod",
            "narkh",
        ],

        radio_narkh: "narkhi_s",

        mikdor_chop: 0,
        mikdor_kuna: 0,
        namud_taksimot: '1',

        edit_nak_form: {},


        mestaho: [
            {text: 'Магазин', value: 1},
            {text: 'Склад', value: 2},
        ],

          MestoRules: [
            v => !!v || 'Выберите место',
          ],
          menu: false,
          menu2: false,
          edit_nak_dialog: false,


          sana1_kuhna: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            sana2_kuhna: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),


      }
    },

    computed: {
        filteredProducts() {
let filter = this.kharids.filter((id_khnakladnoy) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_khnakladnoy[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},

        dateRangeText () {
                    return this.dates.join(' - ')
        },
    },
    mounted () {
        this.usd = this.$session.get('usd')
        this.rub = this.$session.get('rub')
        this.get_firmaho()

       this.get_kharids()



    },
    watch: {





    },
    methods: {
        show_table_kharid(){
            this.sum_kharid = 0;
            this.sum_skidka = 0;
            this.sum_k_oplate = 0;

            this.date1 = this.sana1_kuhna
            this.date2 = this.sana2_kuhna


            this.get_kharids();
            this.table_kharid = true
            this.table_kharid_0 = false
            this.table_kharid_1 = false
            this.kharid =[];
        },
        cur(){
            this.usd = this.$session.get('usd')
            this.rub = this.$session.get('rub')
            this.currency = false;

        },

        sumField(key) {
        return  this.filteredProducts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
        },

        sumFurush(key) {
        return  this.vozvrat_list.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
        },


        get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

        get_kharids(){
            try{
                this.$refs.menu.save(this.date1)
                this.$refs.menu2.save(this.date2)
            }catch(e){
               // console.log(e)
            }


            this.loading = true;
            // this.sana.from = this.dates[0]
            // this.sana.to = this.dates[1]
            this.sana.from = this.date1
            this.sana.to = this.date2
            this.menu_dates = false;
            this.new_nakladnoy = false;

            axios.post('/api/get_kharids', this.sana, {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    this.kharids = response.data.kharids;
                    this.error = true;
                    this.error_message = response.data.message;
                    this.rang = "#4CAF50";
                    setTimeout(() => {
                            this.error = false;
                        }, 2000);
                    }else{
                        this.loading = false;
                        this.error = true;
                        this.error_message = "Ошибка получение накладных";
                        this.kharids =[];
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                    this.kharids =[];
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

            },

            get_kharids_from_kod(){
            try{
                this.$refs.menu.save(this.date1)
                this.$refs.menu2.save(this.date2)
            }catch(e){
               // console.log(e)
            }


            this.loading = true;
            // this.sana.from = this.dates[0]
            // this.sana.to = this.dates[1]
            this.sana.from = this.date1
            this.sana.to = this.date2
            this.sana.kod = this.search_kod
            this.menu_dates = false;
            this.new_nakladnoy = false;

            axios.post('/api/get_kharids_from_kod', this.sana, {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    this.kharids = response.data.kharids;
                    this.error = true;
                    this.error_message = response.data.message;
                    this.rang = "#4CAF50";
                    this.search_kod = "";
                    setTimeout(() => {
                            this.error = false;
                        }, 2000);
                    }else{
                        this.loading = false;
                        this.error = true;
                        this.error_message = "Ошибка получение накладных";
                        this.kharids =[];
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                    this.kharids =[];
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

            },

        currency_changer(){
             this.currency = !this.currency;
            // this.usd = this.$session.get('usd')
            // this.rub = this.$session.get('rub')



        },
        getColor (holat) {
        if (holat == 'Не Проведен') return 'red'
        else if (holat == "Проведен") return 'green'
        else return 'orange'
      },
      getIcon (holat) {
        if (holat == 'Не Проведен') return 'mdi-clock'
        else if (holat == "Проведен") return 'mdi-check'
        else if (holat == "Открыто") return 'mdi-lock-open-variant'
        else return 'mdi-file-question'
      },
      show_kharid(event, {item}){
        this.sana1_kuhna = this.date1;
        this.sana2_kuhna = this.date2;
        this.id_khnakladnoy = item.id_khnakladnoy;
        if(item.holat == 'Не Проведен'){
            this.kharid =[];
            this.table_kharid = false;
            this.table_kharid_0 = true;
            this.show_kharid_of_nakladnoy();
            this.nom_firma = item.firma_nom;
            this.valuta_firma = item.nom;
            this.id_firma = item.id_firma;
            this.id_kurb_firma = item.id_kurb;
        }else if(item.holat == 'Проведен'){
            this.kharid =[];
            this.table_kharid = false;
            this.table_kharid_1 = true;
            this.show_kharid_of_nakladnoy();
            this.nom_firma = item.firma_nom;
            this.valuta_firma = item.nom;
            this.id_firma = item.id_firma;
            this.id_kurb_firma = item.id_kurb;
        }else if(item.holat == 'Открыто'){
            this.kharid =[];
            this.error = true;
            this.error_message = "Накладная уже открыта";
            setTimeout(() => {
                this.error = false;
                this.error_message = "";
            }, 2000);
        }else{
            this.kharid =[];
            this.error = true;
            this.error_message = "Ошибка при открытии накладной";
            setTimeout(() => {
                this.error = false;
                this.error_message = "";
            }, 2000);
        }

      },
      show_poisk(){
        this.poisk_dialog = !this.poisk_dialog;
        this.get_molho();
      },

        get_molho(){
                this.loading = true;
                axios.get('/api/molho',  {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                        this.loading = false;
                        this.molho = response.data.molho;
                        setTimeout(() => {
                                this.error = false;
                            }, 2000);
                        }else{
                            this.loading = false;
                            this.error = true;
                            this.error_message = "Ошибка получение накладных";
                            this.molho =[];
                            setTimeout(() => {
                                this.error = false;
                            }, 2000);

                        }

                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                        this.error_message = error.response.data.message;
                        this.kharids =[];
                            setTimeout(() => {
                                this.error = false;
                            }, 2000);
                    });
        },

        show_kharid_of_nakladnoy(){
            this.poisk_dialog = false;

            this.loading = true;
                axios.get('/api/show_kharid_of_nakladnoy/'+(this.id_khnakladnoy),  {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                        this.loading = false;
                        this.sum_k_oplate = 0;
                            this.sum_kharid = 0;
                            this.sum_skidka = 0;

                            this.kharid = response.data.kharid;
                            this.sum_k_oplate = parseFloat( response.data.sum_k_oplate).toFixed(3);
                            this.sum_kharid = parseFloat( response.data.sum_kharid).toFixed(3);
                            this.sum_skidka = parseFloat( response.data.sum_skidka).toFixed(3);


                        }else{
                            this.loading = false;
                            this.error = true;
                            this.error_message = "Ошибка получение накладных";
                            this.kharid =[];

                            setTimeout(() => {
                                this.error = false;
                            }, 2000);

                        }

                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                        this.error_message = error.response.data.message;
                        this.kharid =[];
                            setTimeout(() => {
                                this.error = false;
                            }, 2000);
                    });

        },

            add_to_list(event, {item}){

                if(item.id_mol!==null){
                this.molho_list.id_mol = item.id_mol;
                // this.molho_list.narkhi_p = item.narkhi_p;
                // this.molho_list.narkhi_f = item.narkhi_f;
                // this.molho_list.narkhi_a = item.narkhi_a;
                // this.molho_list.id_kurb = item.id_kurb;
            }
                this.molho_list.id_nakl = this.id_khnakladnoy

                this.loading = true;

                    axios.post('/api/insert_to_kharid', this.molho_list,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                            this.loading = false;
                            this.error = true;
                            this.error_message = response.data.message;
                            //this.molho = response.data.molho;
                            this.poisk_dialog = false;
                            this.show_kharid_of_nakladnoy();
                            setTimeout(() => {
                                    this.error = false;
                                }, 2000);
                            }else{
                                this.loading = false;
                                this.error = true;
                                this.error_message = "Ошибка Сохранение";
                                this.rang = "#c50000";
                                setTimeout(() => {
                                    this.error = false;
                                }, 2000);

                            }

                        })
                        .catch(error => {
                            this.loading = false;
                            this.error = true;
                            this.error_message = error.response.data.message;
                            this.poisk_dialog = false;
                                setTimeout(() => {
                                    this.error = false;
                                }, 2000);
                        });

            },

            save_mikdor (props) {
               // this.snack = true
               // this.snackColor = 'success'
               // this.snackText = 'Data saved'

                    this.qurbnoma[1] = 1;
                    this.qurbnoma[2] = this.$session.get('usd');
                    this.qurbnoma[3] = this.$session.get('rub');

                    var a = (parseFloat(props.item.narkh_kuna) * parseFloat(this.qurbnoma[props.item.kurb_kuna]))/(parseFloat(this.qurbnoma[props.item.kurb_nav]));

                    if(props.item.ost_kuna<0){
                     var b = props.item.ost_kuna = 0;
                    }else{
                      var b = parseFloat(props.item.ost_kuna);
                    }

                    var c = parseFloat(props.item.mikdor);
                    var d = parseFloat(props.item.narkhi_o) - parseFloat(props.item.skidka);
                    var res = (a*b);
                    var res1 = (c*d);
                    var res2 = (res+res1);
                    var res3 = (c+b);
                    var  result = (res2 / res3);
                    props.item.narkhi_a = parseFloat( result).toFixed(3);
                    props.item.marja = parseFloat( ((parseFloat( props.item.narkhi_f) / parseFloat( props.item.narkhi_a)) * 100) - 100).toFixed(2);




               this.loading = true;
            axios.get('/api/mikdor/'+(this.id_khnakladnoy) +"/"+(props.item.id_mol) +"/"+(props.item.mikdor)+"/"+(props.item.narkhi_a),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                    props.item.summa = parseFloat( (parseFloat(props.item.narkhi_o) - parseFloat(props.item.skidka)) * parseFloat(props.item.mikdor)).toFixed(3);

                        this.$session.start();

                        this.sum_kharid =0;
                        this.sum_skidka =0;
                        this.sum_k_oplate =0;
                    for(let i =0; i <this.kharid.length; i++){
                            this.sum_kharid = this.sum_kharid + (parseFloat(this.kharid[i]['mikdor']) * parseFloat(this.kharid[i]['narkhi_o']));
                            this.sum_skidka = this.sum_skidka + (parseFloat(this.kharid[i]['skidka']) * parseFloat(this.kharid[i]['mikdor']));
                            this.sum_k_oplate = this.sum_k_oplate + (parseFloat(this.kharid[i]['summa']));

                        }




                    }else{
                        this.loading = false;
                        this.error = true;
                        this.error_message = "Ошибка получение накладных";

                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;

                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });


            },

            save_narkhi_o (no) {

                    this.qurbnoma[1] = 1;
                    this.qurbnoma[2] = this.$session.get('usd');
                    this.qurbnoma[3] = this.$session.get('rub');



                   let a = (parseFloat(no.item.narkh_kuna) * parseFloat(this.qurbnoma[no.item.kurb_kuna]))/(parseFloat(this.qurbnoma[no.item.kurb_nav]));

                   if(no.item.ost_kuna<0){
                     var b = no.item.ost_kuna = 0;
                    }else{
                      var b = parseFloat(no.item.ost_kuna);
                    }

                  // let b = parseFloat(no.item.ost_kuna);
                   var c = parseFloat(no.item.mikdor);
                   var d = parseFloat(no.item.narkhi_o) - parseFloat(no.item.skidka);
                    var res = (a*b);
                    var res1 = (c*d);
                    var res2 = (res+res1);
                    var res3 = (c+b);
                   var  result = (res2 / res3);
                    no.item.narkhi_a =parseFloat( result).toFixed(3);
                    no.item.marja = parseFloat( ((parseFloat( no.item.narkhi_f) / parseFloat( no.item.narkhi_a)) * 100) - 100).toFixed(2);


               this.loading = true;
            axios.get('/api/narkhi_o/'+(this.id_khnakladnoy) +"/"+(no.item.id_mol) +"/"+(no.item.narkhi_o)+"/"+(no.item.narkhi_a),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                    no.item.summa = parseFloat( (parseFloat(no.item.narkhi_o) - parseFloat(no.item.skidka)) * parseFloat(no.item.mikdor)).toFixed(3);
                        this.sum_kharid =0;
                        this.sum_skidka =0;
                        this.sum_k_oplate =0;
                    for(let i =0; i <this.kharid.length; i++){
                            this.sum_kharid = this.sum_kharid + (parseFloat(this.kharid[i]['mikdor']) * parseFloat(this.kharid[i]['narkhi_o']));
                            this.sum_skidka = this.sum_skidka + (parseFloat(this.kharid[i]['skidka']) * parseFloat(this.kharid[i]['mikdor']));
                            this.sum_k_oplate = this.sum_k_oplate + (parseFloat(this.kharid[i]['summa']));

                        }

                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);



                    }

                })
                .catch(error => {
                    this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });


            },
            save_skidka (sk) {
                this.qurbnoma[1] = 1;
                    this.qurbnoma[2] = this.$session.get('usd');
                    this.qurbnoma[3] = this.$session.get('rub');

                   var a = (parseFloat(sk.item.narkh_kuna) * parseFloat(this.qurbnoma[sk.item.kurb_kuna]))/(parseFloat(this.qurbnoma[sk.item.kurb_nav]));
                  // let b = parseFloat(sk.item.ost_kuna);

                   if(sk.item.ost_kuna<0){
                     var b = sk.item.ost_kuna = 0;
                    }else{
                      var b = parseFloat(sk.item.ost_kuna);
                    }


                   var c = parseFloat(sk.item.mikdor);
                   var d = parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka);
                    var res = (a*b);
                    var res1 = (c*d);
                    var res2 = (res+res1);
                    var res3 = (c+b);
                    var  result = (res2 / res3);
                    sk.item.narkhi_a =parseFloat( result).toFixed(3);
                    sk.item.marja = parseFloat( ((parseFloat( sk.item.narkhi_f) / parseFloat( sk.item.narkhi_a)) * 100) - 100).toFixed(2);


               this.loading = true;
            axios.get('/api/skidka/'+(this.id_khnakladnoy) +"/"+(sk.item.id_mol) +"/"+(sk.item.skidka)+"/"+(sk.item.narkhi_a),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                    sk.item.summa = parseFloat( (parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka)) * parseFloat(sk.item.mikdor)).toFixed(3);
                        this.sum_kharid =0;
                        this.sum_skidka =0;
                        this.sum_k_oplate =0;

                    this.sum_kharid =0;
                        this.sum_skidka =0;
                        this.sum_k_oplate =0;
                    for(let i =0; i <this.kharid.length; i++){
                            this.sum_kharid = this.sum_kharid + (parseFloat(this.kharid[i]['mikdor']) * parseFloat(this.kharid[i]['narkhi_o']));
                            this.sum_skidka = this.sum_skidka + (parseFloat(this.kharid[i]['skidka']) * parseFloat(this.kharid[i]['mikdor']));
                            this.sum_k_oplate = this.sum_k_oplate + (parseFloat(this.kharid[i]['summa']));

                        }

                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });


            },

            save_narkhi_f (nf) {
                if( parseFloat( nf.item.narkhi_a) > 0){



               this.loading = true;
            axios.get('/api/narkhi_f/'+(this.id_khnakladnoy) +"/"+(nf.item.id_mol) +"/"+(nf.item.narkhi_f),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                   // sk.item.summa =  (parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka)) * parseFloat(sk.item.mikdor);



                    nf.item.marja = parseFloat( ((Number(nf.item.narkhi_f)*Number(100))/ Number(nf.item.narkhi_a)) - Number(100)).toFixed(2);


                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

            }else{
                this.snack = true
                this.snackColor = 'error'
                this.snackText = ' Цена продажа не может быть меньше  себестоимости'
               nf.item.narkhi_f = 0;
               // nf.item.marja = parseFloat( ((Number(nf.item.narkhi_f)*Number(100))/ Number(nf.item.narkhi_a)) - Number(100)).toFixed(2);

               this.loading = true;
             axios.get('/api/narkhi_f/'+(this.id_khnakladnoy) +"/"+(nf.item.id_mol) +"/0",  {
                headers: {
                    "Content-type": "application/json"
                }
             })
             .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                   // sk.item.summa =  (parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka)) * parseFloat(sk.item.mikdor);

                    nf.item.marja = parseFloat( ((Number(nf.item.narkhi_f)*Number(100))/ Number(nf.item.narkhi_a)) - Number(100)).toFixed(2);


                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        nf.item.narkhi_f = 0;

                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });


             }


            },

            save_narkhi_opt (opt) {
                if( parseFloat( opt.item.narkhi_a) > 0){



               this.loading = true;
            axios.get('/api/narkhi_opt/'+(this.id_khnakladnoy) +"/"+(opt.item.id_mol) +"/"+(opt.item.narkhi_opt),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message

                    }else{
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

            }else{
                this.snack = true
                this.snackColor = 'error'
                this.snackText = ' Цена оптовый не может быть меньше  себестоимости'
                opt.item.narkhi_f = 0;
                opt.item.marja =0;
                opt.item.narkhi_opt = 0;


            }


            },

            save_marja(mj) {
                if( parseFloat( mj.item.narkhi_a) > 0){

                this.marjaa = parseFloat( ((Number(mj.item.marja) * Number(mj.item.narkhi_a) / 100) + Number(mj.item.narkhi_a))).toFixed(3);

               this.loading = true;
            axios.get('/api/narkhi_f/'+(this.id_khnakladnoy) +"/"+(mj.item.id_mol) +"/"+(this.marjaa),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                   // sk.item.summa =  (parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka)) * parseFloat(sk.item.mikdor);
                   mj.item.narkhi_f = parseFloat( ((Number(mj.item.marja) * Number(mj.item.narkhi_a) / 100) + Number(mj.item.narkhi_a))).toFixed(3);

                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

            }else{
                this.snack = true
                this.snackColor = 'error'
                this.snackText = ' Цена продажа не может быть меньше  себестоимости'

              //  mj.item.narkhi_f = 0;
               // mj.item.marja = 0;


               this.marjaa = parseFloat( ((Number(mj.item.marja) * Number(mj.item.narkhi_a) / 100) + Number(mj.item.narkhi_a))).toFixed(3);

                this.loading = true;
                axios.get('/api/narkhi_f/'+(this.id_khnakladnoy) +"/"+(mj.item.id_mol) +"/"+(this.marjaa),  {
                headers: {
                    "Content-type": "application/json"
                }
                })
                .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message
                    // sk.item.summa =  (parseFloat(sk.item.narkhi_o) - parseFloat(sk.item.skidka)) * parseFloat(sk.item.mikdor);
                    mj.item.narkhi_f = parseFloat( ((Number(mj.item.marja) * Number(mj.item.narkhi_a) / 100) + Number(mj.item.narkhi_a))).toFixed(3);

                    }else{
                        this.loading = false;

                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message

                        mj.item.narkhi_f = 0;
                        mj.item.marja = 0;

                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });



            }


            },

            save_srok(sr) {

               this.loading = true;
            axios.get('/api/save_srok/'+(this.id_khnakladnoy) +"/"+(sr.item.id_mol) +"/"+(sr.item.muhlati_istifoda),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.loading = false;
                    //this.kharid = response.data.kharid;
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = response.data.message



                    }else{
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = response.data.message
                        setTimeout(() => {
                            this.snackText = '';
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });



            },


            provesti(){
                if(this.kharid.length==0){
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = 'Нет товаров для проведения'
                    this.holat_nak = 0;
                }else{
                    let save = true
                    let date =  moment(date).format('YYYY-MM-DD')
                    for(let i=0;  i<this.kharid.length; i++){
                        if(parseFloat( this.kharid[i]['mikdor']) <= 0 || parseFloat( this.kharid[i]['narkhi_o']) <= 0  || parseFloat( this.kharid[i]['narkhi_a']) <= 0  || parseFloat( this.kharid[i]['narkhi_f']) <= 0 || parseFloat( this.kharid[i]['marja']) < 0 || parseFloat( this.kharid[i]['skidka']) > parseFloat( this.kharid[i]['narkhi_o']) || (this.kharid[i]['muhlatnok']==1 && this.kharid[i]['muhlati_istifoda'] <= date)  ) {
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = 'Ошибка! Проверьте список'
                            this.holat_nak = false;
                            save = false
                          //  break;
                        }
                    }

            if(save==true){
            this.loading = true;
            axios.post('/api/holat_nak/'+(this.id_khnakladnoy) +"/1/"+(this.id_firma)+"/"+(this.valuta_firma), this.kharid,  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;
                    this.holat_nak = false

                    this.s_oplata = Number(this.sum_k_oplate).toFixed(2);
                    this.oplata_dialog = true;
                   // this.show_table_kharid();


                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

                        }


                }

            },

            deleteMol(ac){

                this.deleteIndex = this.kharid.indexOf(ac.item);
                this.kharid.splice(this.deleteIndex, 1);



                this.loading = true;
            axios.get('/api/delete/'+(this.id_khnakladnoy) +"/"+ ac.item.id_mol,  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;

                    this.sum_kharid =0;
                        this.sum_skidka =0;
                        this.sum_k_oplate =0;
                    for(let i =0; i <this.kharid.length; i++){
                            this.sum_kharid = this.sum_kharid + (parseFloat(this.kharid[i]['mikdor']) * parseFloat(this.kharid[i]['narkhi_o']));
                            this.sum_skidka = this.sum_skidka + (parseFloat(this.kharid[i]['skidka']) * parseFloat(this.kharid[i]['mikdor']));
                            this.sum_k_oplate = this.sum_k_oplate + (parseFloat(this.kharid[i]['summa']));

                        }


                    this.show_kharid_of_nakladnoy();


                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });




            },

            save_natsenka(){

                this.loading = true;

                if(this.natsenka_input < 0){
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = 'Нельзя применить наценку к товару с нулевым количеством или нулевой ценой'
                    this.loading = false;
                    return false;
                }else{

                    if( this.natsenka_input > 0){
                        let nol = false;
                        for(let i=0; i<this.kharid.length; i++){
                            if(parseFloat( this.kharid[i]['mikdor'])<= 0 || parseFloat( this.kharid[i]['narkhi_o']) <= 0){
                                nol = true;
                                break;
                            }
                        }
                        if(nol==false){


                            this.loading = true;
            axios.post('/api/natsenka/'+(this.id_khnakladnoy) +"/"+(this.natsenka_input) + "/" + this.natsenka_radio, this.kharid,  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;

                    this.show_kharid_of_nakladnoy();
                    this.dialog_natsenka = false;
                    this.natsenka_input = 0;
                    this.natsenka_radio = 1;


                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

                        }else{
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = 'Проверьте список'
                            this.loading = false;
                            this.dialog_natsenka = false;
                            return false;
                        }


                    }else{
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = ' значения наценки не выбран'
                        this.loading = false;
                        this.dialog_natsenka = false;
                        return false;
                    }
                }


            },
            export_to_excel(){

                alert('Экспорт в Excel временно не доступен')
            },

            save_skidka_n(){

                    this.loading = true;

                    if(this.skidka_input < 0){
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = 'Нельзя применить скидку менее 1'
                        this.loading = false;
                        return false;
                    }else{

                        if( this.skidka_input > 0){
                            let nol = false;
                            for(let i=0; i<this.kharid.length; i++){
                                if(parseFloat( this.kharid[i]['mikdor'])<= 0 || parseFloat( this.kharid[i]['narkhi_o']) <= 0){
                                    nol = true;
                                    break;
                                }
                            }
                            if(nol==false){

            this.loading = true;
            axios.post('/api/skidka_vsem/'+(this.id_khnakladnoy) +"/"+(this.skidka_input)+"/"+(this.radios)+"/"+(this.sum_kharid), this.kharid,  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;

                    this.show_kharid_of_nakladnoy();
                    this.dialog_skidka = false;


                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

                            }else{
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = 'Проверьте список, нельзя применить скидку к товару с нулевым количеством или нулевой ценой'
                                this.loading = false;
                                this.dialog_skidka = false;
                                return false;
                            }
                            }else{
                                this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = 'Нельзя применить скидку менее 1'
                                            this.loading = false;
                                            return false;
                            }
            }
        },

        otmena_nak(){


            this.loading = true;
            axios.post('/api/holat_nak/'+(this.id_khnakladnoy) +"/0/"+(this.id_firma)+"/"+(this.valuta_firma), this.kharid,  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;
                    this.otmena_nak_dialog = false;
                    this.show_table_kharid();
                    this.kharid = [];

                    }else{
                        this.loading = false;

                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });


        },

        Print(chop){
        //  this.dialog_chop = true;
        this.barcode_dialog = true;
          this.chop = chop.item;
          this.mikdor_chop = this.chop.mikdor;
          this.mikdor_kuna = this.chop.mikdor;

        },


        printDiv() {
            let contents = document.getElementById("printable").innerHTML;
                let frame1 = document.createElement('iframe');
                frame1.name = "frame1";
                frame1.style.position = "absolute";
                frame1.style.top = "-1000000px";
                document.body.appendChild(frame1);
                let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                frameDoc.document.open();




                frameDoc.document.write(this.css);
                frameDoc.document.write('</head><body>');
                frameDoc.document.write(contents);
                frameDoc.document.write('</body></html>');
                frameDoc.document.close();
                setTimeout(function () {
                    window.frames["frame1"].focus();
                    window.frames["frame1"].print();
                    document.body.removeChild(frame1);
                }, 500);
                return false;
            },


            getColorSrok (sr) {
              let date =  moment(date).format('YYYY-MM-DD')
                if(sr.item.muhlatnok==1){
                    if (  sr.item.muhlati_istifoda <= date ) return 'red'
                    else if (sr.item.muhlati_istifoda == null) return 'yellow'
                    else if (sr.item.muhlati_istifoda == 0) return 'yellow'
                    else if ( sr.item.muhlati_istifoda >=  date) return 'green'
                    else return 'yellow'
                }else{
                    return 'white'


                }






      },


      search_mol(){
            this.molho = [];
            this.loading = true;
            var kod = +this.search_molho;
            axios.get('/api/search_mol/'+(kod),  {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.rang = 'success';
                    this.loading = false;
                    this.error = true;
                    this.error_message = response.data.message;
                    this.add_to_list2(response.data.id_mol)
                    this.get_molho();
                    this.search_molho = '';
                    }else{
                        this.loading = false;
                        this.get_molho();
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                    this.get_molho();
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

                },


                add_to_list2(mol_id){

                    if(mol_id!==null){
                    this.molho_list.id_mol = mol_id;
                    }
                    this.molho_list.id_nakl = this.id_khnakladnoy



                    this.loading = true;

                        axios.post('/api/insert_to_kharid', this.molho_list,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                //this.molho = response.data.molho;
                                this.poisk_dialog = false;
                                this.show_kharid_of_nakladnoy();
                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });

                    },

                    new_mol_update(){
                    this.newmol = false;
                    this.get_molho();
                    },

                    cancel(){},
                    open(){},
                    close(){},


                    add_from_newmol(id_mol){
                    this.molho_list.id_mol = id_mol;
                    this.molho_list.id_nakl = this.id_khnakladnoy;
                    this.loading = true;

                        axios.post('/api/insert_to_kharid', this.molho_list,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                //this.molho = response.data.molho;
                                this.poisk_dialog = false;
                                this.show_kharid_of_nakladnoy();
                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });


                    },

                    new_mol_from_search(){
                        this.poisk_dialog = false;
                        this.newmol = true;
                    },


    chop_1540(){
        this.loading = true;
        var nom = '';
        var kod = 0;
        var mikdor = 0;
        var narkhi_s = 0;
        var narkhi_v = 0;
        var id_kurb_firma = this.id_kurb_firma;
        var namud = 1;
        var size = 1;
        var shifr = 0;
        var narkhi_opt = this.chop.narkhi_opt;
        if(this.label_1540.includes('nom')){
            nom = this.chop.nom;
        }
        if(this.label_1540.includes('kod')){
            kod = this.chop.kod;
        }
        if(this.label_1540.includes('shifr')){
            shifr = 1
        }


        if(this.mikdor_chop>0){
            mikdor = this.mikdor_chop;
        }else{
            mikdor = 1;
        }

        if(this.label_1540.includes('narkh')){

            if(this.radio_narkh=='narkhi_v'){
            narkhi_v = this.chop.narkhi_f;
            narkhi_s =0;
        }else if(this.radio_narkh=='narkhi_s'){
            if(id_kurb_firma==1){
                narkhi_v =0;
                narkhi_s = this.chop.narkhi_f;
            }else if(id_kurb_firma==2){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.usd);
            }else if(id_kurb_firma==3){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.rub);
            }else{
                narkhi_v = parseFloat( this.chop.narkhi_f);
                narkhi_s = parseFloat( this.chop.narkhi_f) ;
            }
        }

        }else{
            narkhi_s = 0;
            narkhi_v = 0;
        }

        var form = {
            nom:nom,
            kod:kod,
            mikdor:mikdor,
            narkhi_s:narkhi_s,
            narkhi_v:narkhi_v,
            namud:namud,
            shifr:shifr,
            size: size,
            narkhi_opt: narkhi_opt
        }

        axios.post('/api/chop_1540', form,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.barcode_dialog = false;
                                this.chop = {};
                                this.mikdor_chop = 0;
                                this.namud_taksimot = 1;


                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });
    },


    chop_3040(){
        this.loading = true;
        var nom = '';
        var kod = 0;
        var mikdor = 0;
        var narkhi_s = 0;
        var narkhi_v = 0;
        var id_kurb_firma = this.id_kurb_firma;
        var namud = 1;
        var size = 2;
        var shifr = 0;
        var narkhi_opt = this.chop.narkhi_opt;
        if(this.label_1540.includes('nom')){
            nom = this.chop.nom;
        }
        if(this.label_1540.includes('kod')){
            kod = this.chop.kod;
        }
        if(this.label_1540.includes('shifr')){
            shifr = 1
        }


        if(this.mikdor_chop>0){
            mikdor = this.mikdor_chop;
        }else{
            mikdor = 1;
        }

        if(this.label_1540.includes('narkh')){

            if(this.radio_narkh=='narkhi_v'){
            narkhi_v = this.chop.narkhi_f;
            narkhi_s =0;
        }else if(this.radio_narkh=='narkhi_s'){
            if(id_kurb_firma==1){
                narkhi_v =0;
                narkhi_s = this.chop.narkhi_f;
            }else if(id_kurb_firma==2){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.usd);
            }else if(id_kurb_firma==3){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.rub);
            }else{
                narkhi_v = parseFloat( this.chop.narkhi_f);
                narkhi_s = parseFloat( this.chop.narkhi_f) ;
            }
        }

        }else{
            narkhi_s = 0;
            narkhi_v = 0;
        }

        if(this.namud_taksimot==1){
            namud = 1;
        }else if(this.namud_taksimot==2){
            namud = 2;
        }else if(this.namud_taksimot==3){
            namud = 3;
        }else if(this.namud_taksimot==4){
            namud = 4;
        }

        var form = {
            nom: nom,
            kod: kod,
            mikdor: mikdor,
            narkhi_s:narkhi_s,
            narkhi_v:narkhi_v,
            namud: namud,
            shifr:shifr,
            size: size,
            narkhi_opt: narkhi_opt
        }

        axios.post('/api/chop_1540', form,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.barcode_dialog = false;
                                this.chop = {};
                                this.mikdor_chop = 0;
                                this.namud_taksimot = 1;

                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });





    },

    chop_6040(){
        this.loading = true;
        var nom = '';
        var kod = 0;
        var mikdor = 0;
        var narkhi_s = 0;
        var narkhi_v = 0;
        var id_kurb_firma = this.id_kurb_firma;
        var namud = 1;
        var size = 3;
        var shifr = 0;
        var narkhi_opt = this.chop.narkhi_opt;
        if(this.label_1540.includes('nom')){
            nom = this.chop.nom;
        }
        if(this.label_1540.includes('kod')){
            kod = this.chop.kod;
        }
        if(this.label_1540.includes('shifr')){
            shifr = 1
        }


        if(this.mikdor_chop>0){
            mikdor = this.mikdor_chop;
        }else{
            mikdor = 1;
        }

        if(this.label_1540.includes('narkh')){

            if(this.radio_narkh=='narkhi_v'){
            narkhi_v = this.chop.narkhi_f;
            narkhi_s =0;
        }else if(this.radio_narkh=='narkhi_s'){
            if(id_kurb_firma==1){
                narkhi_v =0;
                narkhi_s = this.chop.narkhi_f;
            }else if(id_kurb_firma==2){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.usd);
            }else if(id_kurb_firma==3){
                narkhi_v =0;
                narkhi_s = parseFloat( this.chop.narkhi_f) * parseFloat(this.rub);
            }else{
                narkhi_v = parseFloat( this.chop.narkhi_f);
                narkhi_s = parseFloat( this.chop.narkhi_f) ;
            }
        }

        }else{
            narkhi_s = 0;
            narkhi_v = 0;
        }

        if(this.namud_taksimot==1){
            namud = 1;
        }else if(this.namud_taksimot==2){
            namud = 2;
        }else if(this.namud_taksimot==3){
            namud = 3;
        }else if(this.namud_taksimot==4){
            namud = 4;
        }

        var form = {
            nom: nom,
            kod: kod,
            mikdor: mikdor,
            narkhi_s:narkhi_s,
            narkhi_v:narkhi_v,
            namud: namud,
            shifr:shifr,
            size: size,
            narkhi_opt: narkhi_opt
        }

        axios.post('/api/chop_1540', form,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.barcode_dialog = false;
                                this.chop = {};
                                this.mikdor_chop = 0;
                                this.namud_taksimot = "1";


                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });





    },



    taksim_kol(m){
        const kol_kuna = parseInt( this.mikdor_kuna);
        const kol_2 = parseInt( kol_kuna/2);
        const kol_3 = parseInt( kol_kuna/3);

        if(m==1){
            this.mikdor_chop  = parseInt(kol_kuna);
        }else if(m==2){
            this.mikdor_chop  = kol_2;
        }else if(m==3){
            this.mikdor_chop  = kol_3;
        }else if(m==4){
            this.mikdor_chop  = kol_kuna;
        }


    },

    close_dialog_chop(){
      this.namud_taksimot = "1";
    },

        startDownload(){
          console.log('show loading');
        },

        finishDownload(){
            console.log('hide loading');
        },

        edit_kharid(item){
            this.edit_nak_form = item;
            this.edit_nak_dialog = true;

        },
        delete_kharid(item){
            this.delete_dialog = true;
            this.id_del_nak = item.id_khnakladnoy;

        },

        confirm_delete_nak(){
            this.loading = true;
            axios.post('/api/delete_kharid', {id: this.id_del_nak},
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.delete_dialog = false;
                                this.get_kharids();
                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });


        },

        change_nak(){

            this.loading = true;
            axios.post('/api/change_nak', this.edit_nak_form,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.edit_nak_dialog = false;
                                this.get_kharids();
                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });


        },

        proverka_nakl(){
            this.show_kharid_of_nakladnoy();

            var checker = 1;
            this.kharid.forEach((item, index) => {
                if(item.mikdor <= 0 || item.narkhi_o <=0 || item.narkhi_f <=0 || item.marja < 0){
                    this.snack = true;
                    this.snackColor = "error";
                    this.snack_message = "Накладная не может быть с нулевым значением";
                    setTimeout(() => {
                        this.snack = false;
                    }, 2000);
                    checker = 0;
                }
            });

            if(checker ==1){
                this.holat_nak = true;
            }else{
                this.holat_nak = false;
            }

        },

        save_pay_firma(){
            this.loading = true;
            this.$session.start();
            this.id_user = this.$session.get('id_user');
            var pay_form = {
                id_firma: this.id_firma,
                summa: this.s_oplata,
                comment: this.comment,
                id_user: this.id_user
            };
            axios.post('/api/save_pay_firma', pay_form,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                this.loading = false;
                                this.error = true;
                                this.error_message = response.data.message;
                                this.oplata_dialog = false;
                                this.show_table_kharid();

                                setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.error = true;
                                    this.error_message = "Ошибка Сохранение";
                                    this.rang = "#c50000";
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.loading = false;
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.poisk_dialog = false;
                                    setTimeout(() => {
                                        this.error = false;
                                    }, 2000);
                            });
        },

        v_dolg(){
            this.oplata_dialog = false;
            this.show_table_kharid();
        },


        back_kharid(){
            this.table_kharid =true;
            this.table_kharid_0 = false;
            this.table_kharid_1 = false;
        }

},
}
</script>

<style scoped>


</style>
